

export const integration = {
    formId: "save-integration",
    formField: {
        integrationName: {
            name: "integrationName",
            label: "integration name",
            type: "text",
            placeholder: "eg. New Integration",
            errorMsg: "Integration Name is required."
        },
        description: {
            name: "description",
            label: "description",
            type: "text",
            placeholder: "eg. This is an information about the integration",
            errorMsg: "Description is required."
        },
        version: {
            name: "version",
            label: "version",
            type: "text",
            placeholder: "eg. 0.0.1",
            errorMsg: "Version is required.",
          },
    }
};